<script>
    import Cybershop from "./Cybershop.svelte";
    import { onMount } from "svelte";
    import { link } from "svelte-spa-router";
    import { wrap } from "svelte-spa-router/wrap";
    import { element } from "svelte/internal";
    import io from "socket.io-client";
    import { chatouvert } from "./Class.js";
    import Hud from "./Hud.svelte";
    import Chat from "./Chat.svelte";
    import Hudjeu from "./Hudjeu.svelte";

    import menucacher from "./Hud.svelte";
    import Stages from "./Stages.svelte";
    import connecter from "./Home.svelte";
    import { getContext, setContext } from "svelte";
    import { Allier, Personnage, Objet } from "./Class.js";
    export let musique;
    import { socket } from "./Variables.js";
    // let socket = getContext("socket");

    export let jeucharger = false;
    let joueur = getContext("joueur");
    $: placeinventaire = joueur.inventaire.length;
    let hudcache = true;
    let windowwidth = window.screen.availWidth;
    let windowheight = window.screen.availHeight;
    let nbjoueurs;
    let joueurlocal;
    let chatfermer = getContext("hudcache");
    let pseudoingame;
    let objet = new Objet(
        "Stimulant",
        90,
        "img/potion.png",
        "consommable",
        "Un cocktail chimique stimulant",
        "+3 force",
        "Onix Corp",
        "standard"
    );
    let objet2 = new Objet(
        "Puce",
        250,
        "img/puce.png",
        "puce",
        "Une puce d'agilité",
        "+1 vitesse",
        "Onix Corp",
        "standard"
    );

    //--------------------------------------------------------------------------fonction et variables du jeu
    export let lancementjeu;
    let faceimg = new Image(100, 200);
    faceimg.src = "/img/persoface.png";
    function stop() {
        audio.remove();
    }
    //--------------------------------------------------------------------------Variables personnages
    let joueuramis = [];
    let dude;
    let cursors;
    let perso;
    let cyberfemale1;
    let lumiere;
    let logo;
    let camera;
    let positionjoueurx;
    let positionjoueury;
    let deplacement = true;
    let perso2;

    let allier;
    let joueurenligne = getContext("joueurenligne");
    $: joueurnligne2 = joueurenligne;
    let joueurcourant;
    let booleanjoueurcourant;
    musique = [new Audio("son/son4.mp3"), new Audio("son/son1.mp3")];
    let effet = [new Audio("son/effet/ambiance.mp3"), new Audio("")];
    let ildaa = [
        new Audio("son/effet/ildaabonjour.mp3"),
        new Audio("son/effet/ildaainventaire.mp3")
    ];
    let track = 0;
    let idjoueur = "";

    function changementmusiquemenu() {
        setInterval(() => {
            musique[track].play();
        }, 1000);
    }

    function stopAudio(audio) {
        audio.pause();
        audio.currentTime = 0;
    }
    //---------------------------------------------------- JEU
    function enregistrementjoueur(
        pseudo,
        cyberz,
        niveau,
        sante,
        attaque,
        defense,
        xp,
        pass,
        inventaire,
        kill,
        score,
        puce,
        amelioration,
        relique
    ) {
        fetch("https://apiildaa.herokuapp.com/sauvegarde", {
            method: "post",
            mode: "cors",
            headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                pseudo: pseudo,
                cyberz: cyberz,
                niveau: niveau,
                sante: sante,
                attaque: attaque,
                defense: defense,
                xp: xp,
                pass: pass,
                inventaire: inventaire,
                kill: kill,
                score: score,
                puce: puce,
                amelioration: amelioration,
                relique: relique
            })
        })
            .then((res) => res.json())
            .then((res) => {
                let response = [];
                response.push(res);

                if (res.compte != undefined) {
                    /* console.log("nouveau compte créer"); */
                    connectionactive === true;
                }
                joueur.pseudo = res.pseudo;
                joueur.cyberz = res.cyberz;
                joueur.niveau = res.niveau;
                joueur.sante = res.sante;
                joueur.attaque = res.attaque;
                joueur.defense = res.defense;
                joueur.xp = res.xp;
                joueur.pass = res.pass;
                joueur.inventaire = res.inventaire;
                joueur.kill = res.kill;
                joueur.score = res.score;
            });
    }
    onMount(async () => {
        //TODO ------------------------------------------------------------------------------- SCENE 1--------------------------

        // --------------------------Scene menu principal ------------------------------------------------
        class SceneA extends Phaser.Scene {
            constructor() {
                super("SceneA");
            }

            //--------------------------------------------------------------------------------------- PRELOAD
            preload() {
                // JOUEUR
                joueur.inventaire.push(objet);
                joueur.inventaire.push(objet2);
                // PNJ

                this.load.image("dude", "/img/boy.png", { frameWidth: 48, frameHeight: 48 });

                // PARTICULE
                this.load.image("particule", "/img/glitter2.png", {
                    frameWidth: 21,
                    frameHeight: 21
                });

                // MAP

                this.load.image("mapimg", "/img/tokyo.png", { frameWidth: 1000, frameHeight: 500 });
            }

            //------------------------------------------------------ CREATE
            create() {
                // CREATION MAP
                this.background = this.add
                    .image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "mapimg")
                    .setOrigin(0.5, 0.5);
                this.background.displayWidth = this.sys.canvas.width;
                this.background.displayHeight = this.sys.canvas.height;

                // CREATION JOUEUR

                // HITBOX

                // this.background.setPipeline("Light2D");
                this.lights.enable();
                // this.lights.setAmbientColor(55, 55, 255);

                var spotlight = this.lights.addLight(300, 300, 1600).setIntensity(3);
                var spotlight2 = this.lights.addLight(1400, 200, 800).setIntensity(3);
                var spotlight3 = this.lights.addLight(690, 200, 800).setIntensity(3);
                var spotlight4 = this.lights.addLight(950, 300, 800).setIntensity(2);
                // // CREATION PARTICULE

                this.input.on("pointermove", function (pointer) {});

                cursors = this.input.keyboard.createCursorKeys();

                // -----------------------------CREATION ANIMATION
            }

            //-----------------------------------------------------------------------------------UPDATE

            update() {
                if (lancementjeu === true) {
                    /* console.log("jeu commencé"); */

                    hudcache = false;
                    joueur.sante += 0;
                    this.scene.start("SceneB", "SceneA");
                }
            }
        }
        class SceneB extends Phaser.Scene {
            constructor() {
                super("SceneB");
            }

            //--------------------------------------------------------------------------------------- PRELOAD
            preload() {
                socket.on("connect", () => {
                    socket.on("nouvelleconnexion", (data) => {
                        // joueurenligne = data.joueurs;
                        console.log(data.joueurs);

                        let infos = {
                            pseudo: joueur.pseudo,
                            persox: 200,
                            persoy: 200
                        };
                        socket.emit("colocal", joueur);
                    });

                    let info = {
                        pseudo: joueur.pseudo,
                        persox: 200,
                        persoy: 200,
                        sprite: "rrr"
                    };

                    socket.on("majcolocal", (data) => {
                        if (data.joueursession.length > 1) {
                            data.joueursession.forEach((element) => {
                                if (element.nom === joueur.pseudo) {
                                } else if (element.nom != joueur.pseudo) {
                                    allier = new Allier(
                                        element.nom,

                                        element.positionx,
                                        element.positiony
                                    );

                                    joueuramis.push(allier);

                                    socket.emit("synchro", joueuramis);
                                }
                            });
                        }
                        console.log(data.joueurs);
                        /* console.log(joueuramis); */
                    });

                    socket.on("majsynchro", (data) => {
                        // joueurenligne = data.joueurs;
                        joueuramis.forEach((element) => {});
                    });

                    console.log(objet);
                    console.log(joueur.inventaire);
                });
                // JOUEUR
                // this.load.spritesheet("perso", "/img/ninja.png", {
                //     frameWidth: 353,
                //     frameHeight: 561
                // });
                this.load.spritesheet("perso2", "/img/perso2.png", {
                    frameWidth: 48,
                    frameHeight: 48
                });
                this.load.spritesheet("cyberfemale1", "/img/ildaa.png", {
                    frameWidth: 528,
                    frameHeight: 842
                });

                this.load.spritesheet("pancarte", "/img/pancarte.png", {
                    frameWidth: 48,
                    frameHeight: 48
                });

                // PNJ

                this.load.image("dude", "/img/boy.png", { frameWidth: 48, frameHeight: 48 });

                // PARTICULE
                this.load.image("particule", "/img/glitter2.png", {
                    frameWidth: 21,
                    frameHeight: 21
                });

                // MAP

                this.load.image("mapimg2", "/img/session.png", {
                    frameWidth: 1000,
                    frameHeight: 500
                });
            }

            //------------------------------------------------------ CREATE
            create() {
                cyberfemale1 = this.physics.add.sprite(
                    windowwidth - 150,
                    windowheight - 500,
                    "cyberfemale1"
                );
                cyberfemale1.setSize(30, 80, true);
                cyberfemale1.setDepth(2);

                joueur.sprite = perso;
                // jeucharger = true;

                this.background = this.add
                    .image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "mapimg2")
                    .setOrigin(0.5, 0.5);
                this.background.displayWidth = this.sys.canvas.width;
                this.background.displayHeight = this.sys.canvas.height;

                this.background.setPipeline("Light2D");
                this.lights.enable();
                this.lights.setAmbientColor(0x808080);

                var spotlight = this.lights.addLight(300, 300, 1500).setIntensity(2);
                var spotlight2 = this.lights.addLight(1200, 300, 800).setIntensity(2);
                var spotlight3 = this.lights.addLight(650, 300, 800).setIntensity(3);

                /* jourensession.forEach(element => {}); */

                camera = this.cameras.main;
                // CREATION MAP

                let testnbjoueur = 3;
                let increment = 10;

                // HITBOX perso.setSize(30, 80, true);

                // z-INDEX

                // COLLISION A LA MAP perso.body.collideWorldBounds = true;
                cyberfemale1.body.collideWorldBounds = true;

                // REBONDS perso.body.setBounce(0, 0);
                cyberfemale1.body.setBounce(0, 0);

                // COLLISION JOUEUR ET LOGO this.physics.add.collider(perso, logo);
                /* this.physics.add.collider(
                    perso,
                    [cyberfemale1, dude, logo]
                    // function colision(perso, cyberfemale1) {

                    // }
                ); */
                // mouvement  perso.setVelocityX(0);
                this.anims.create({
                    key: "walkfemale",
                    frames: this.anims.generateFrameNumbers("cyberfemale1", {
                        frames: [
                            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0,
                            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                            0, 0
                        ]
                    }),
                    frameRate: 8,
                    repeat: -1
                });
                cyberfemale1.setVelocityX(0);
                cyberfemale1.play("walkfemale");
                // perso.setTexture('perso2')  // CHANGER L IMAGE SOURCE
                /* console.log(perso.getBounds()); */ // DIMENSION ET POSIITON DE PERSO
                //perso.setPosition(perso.x,perso.y) // DEPLACER

                // CREATION PNJbutt

                logo = this.physics.add.image(800, 900, "particule");
                logo.body.setSize(21, 21);
                logo.setVelocity(100, 200);
                logo.setBounce(1, 1);
                logo.setCollideWorldBounds(true);

                // CREATION PARTICULE

                const particles = this.add.particles("particule");

                cursors = this.input.keyboard.createCursorKeys();

                var emitter = particles.createEmitter({
                    speed: 200,
                    scale: { start: 0, end: 0.3 },
                    blendMode: "ADD"
                });

                emitter.startFollow(logo);
                /* console.log(cursors);
        console.log(perso.getBounds()); */
                /* 
                // -----------------------------CREATION ANIMATION
                
                this.anims.create({
                    key: "walk",
                    frames: this.anims.generateFrameNumbers("perso", { frames: [0, 1, 0, 2, 0] }),
                    frameRate: 5,
                    repeat: -1
                });

                this.anims.create({
                    key: "walkright",
                    frames: this.anims.generateFrameNumbers("perso", { frames: [3, 4, 3, 5, 3] }),
                    frameRate: 9,
                    repeat: -1
                });
                this.anims.create({
                    key: "walkleft",
                    frames: this.anims.generateFrameNumbers("perso", { frames: [8, 7, 8, 6, 8] }),
                    frameRate: 9,
                    repeat: -1
                });
                this.anims.create({
                    key: "walkup",
                    frames: this.anims.generateFrameNumbers("perso", { frames: [9, 10, 9, 11, 9] }),
                    frameRate: 9,
                    repeat: -1
                });
 */
                let mort = true;

                camera.fadeIn(2000, 1);
                /* musique[track].play() */

                socket.on("colocal", (data) => {});

                this.input.on(
                    "pointerup",
                    function ClickNuke() {
                        /*  this.scale.startFullscreen() */
                        if (joueur.sante > 0) {
                        } else {
                        }
                        let infos = {
                            persox: 200,
                            persoy: 200,
                            pseudoid: joueur.pseudo,
                            x: 200,
                            y: 200
                        };

                        socket.emit("synchro", joueuramis);
                    },
                    this
                );
                socket.on("mouvementmaj", (data) => {});

                /*  joueuramis.forEach((element) => {
                if (element.pseudo===) {
                }
            }); */
            }

            //TODO ------------------------------------------------- Update--------------------------
            update() {
                // -------------------------conditon si la touche est relacher

                // cursors.down.on("up", function (event) {
                //     perso.stop("walk");
                //     perso.setVelocity(0, 0);
                // });
                // cursors.up.on("up", function (event) {
                //     perso.stop("walkup");
                //     perso.setVelocity(0, 0);
                // });
                // cursors.left.on("up", function (event) {
                //     perso.stop("walkleft");
                //     perso.setVelocity(0, 0);
                // });
                // cursors.right.on("up", function (event) {
                //     perso.stop("walkright");
                //     perso.setVelocity(0, 0);
                // });
                // -------------------------conditon si la touche est appuyé
                // cursors.down.on("down", function (event) {
                //     perso.play("walk");

                //     perso.setVelocity(0, -300);
                // });

                // cursors.up.on("down", function (event) {
                //     perso.play("walkup");
                //     perso.setVelocity(0, -300);
                // });

                // cursors.left.on("down", function (event) {
                //     perso.play("walkleft");
                //     perso.setVelocity(0, -300);
                // });
                // cursors.right.on("down", function (event) {
                //     perso.play("walkright");
                //     perso.setVelocity(0, -300);
                // });

                // var keyObj = this.input.keyboard.addKey('W');  // Get key object

                if (cursors.space.isDown) {
                    console.log("scene c");
                    this.scene.start("SceneC");
                    lancementjeu = true;
                    hudcache = true;
                    jeucharger = true;
                    // chatouvert = false;
                    console.log(chatfermer);
                    /* this.physics.moveToObject(cyberfemale1, perso, 120);

                    this.physics.moveToObject(logo, perso, 120); */
                } else {
                }

                // perso.setVelocity(0);

                // if (cursors.up.isDown && deplacement === true) {
                //     perso.setVelocity(0, -300);
                // }
                // if (cursors.down.isDown && deplacement === true) {
                //     perso.setVelocity(0, 200);
                //     // perso.play('walk');
                // }

                // if (cursors.left.isDown && deplacement === true) {
                //     perso.setVelocity(-300, 0);
                // }
                // if (cursors.right.isDown && deplacement === true) {
                //     perso.setVelocity(300, 0);
                // }
                // if (cursors.up.isDown && cursors.left.isDown && deplacement === true) {
                //     perso.setVelocity(-300, -200);
                // }
                // if (cursors.up.isDown && cursors.right.isDown && deplacement === true) {
                //     perso.setVelocity(300, -300);
                // }

                // if (cursors.down.isDown && cursors.left.isDown && deplacement === true) {
                //     perso.setVelocity(-300, 200);
                // }
                // if (cursors.down.isDown && cursors.right.isDown && deplacement === true) {
                //     perso.setVelocity(300, 300);
                // }

                if (lancementjeu === false) {
                    this.scene.start("SceneA", "SceneB");
                }
            }
        }

        class SceneC extends Phaser.Scene {
            constructor() {
                super("SceneC");
            }

            //--------------------------------------------------------------------------------------- PRELOAD
            preload() {
                this.load.spritesheet("perso22", "/img/ninja.png", {
                    frameWidth: 212,
                    frameHeight: 336
                });
                this.load.spritesheet("nuage", "/img/nuage.png", {
                    frameWidth: 353,
                    frameHeight: 561
                });
                this.load.image("mapimg3", "/img/niveau1.png", {
                    frameWidth: 1000,
                    frameHeight: 500
                });
                this.load.spritesheet("lumiere", "/img/lumiere.png", {
                    frameWidth: 528,
                    frameHeight: 842
                });
                // JOUEUR
            }

            //------------------------------------------------------ CREATE
            create() {
                cyberfemale1 = this.physics.add.sprite(
                    windowwidth - 150,
                    windowheight - 500,
                    "cyberfemale1"
                );
                cyberfemale1.setSize(30, 80, true);
                cyberfemale1.setDepth(2);

                hudcache = false;
                perso = this.physics.add.sprite(
                    windowwidth - windowwidth + 250,
                    windowheight - 400,
                    "perso22"
                );
                var style = {
                    font: "10px scifi",
                    fill: "chartreuse",
                    wordWrap: true,
                    wordWrapWidth: perso.width,
                    align: "center"
                };

                pseudoingame = this.add.text(0, 0, joueur.pseudo, style);
                cursors = this.input.keyboard.createCursorKeys();

                lumiere = this.physics.add.sprite(
                    windowwidth - windowwidth + 1150,
                    windowheight - 700,
                    "lumiere"
                );
                camera = this.cameras.add(0, 0, 1400, 900);
                camera.shake(1000, 0.025);

                /* camera.setZoom(4); */
                /* this.cameras.main.startFollow(perso, true, 0.09, 0.09); */
                camera.setBackgroundColor("rgba(0, 0, 0, 0)");
                this.anims.create({
                    key: "clignotement",
                    frames: this.anims.generateFrameNumbers("lumiere", {
                        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 8, 7, 6, 5, 4, 3, 2, 1]
                    }),
                    frameRate: 4,
                    repeat: -1
                });

                lumiere.setDepth(3);
                pseudoingame.setDepth(3);
                perso.setSize(30, 80, true);
                perso.setDepth(2);
                this.background = this.add
                    .image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "mapimg3")
                    .setOrigin(0.5, 0.5);
                this.background.displayWidth = this.sys.canvas.width;
                this.background.displayHeight = this.sys.canvas.height;

                this.background.setPipeline("Light2D");
                this.lights.enable();
                this.lights.setAmbientColor(0xffffff);

                var spotlight = this.lights.addLight(1, 200, 1500).setIntensity(3);

                // -----------------------------CREATION ANIMATION

                lumiere.play("clignotement");
                if (cursors.up.isDown) {
                    perso.setVelocity(0, 200);
                    console.log("oui");

                    // perso.play('walk');
                }
                const particles = this.add.particles("particule");
                var emitter = particles.createEmitter({
                    speed: 200,
                    scale: { start: 0, end: 0.3 },
                    blendMode: "ADD"
                });

                emitter.startFollow(perso);
                console.log("create");
                /*             this.input.on('pointermove', (pointer) => {

(pointer.x)

}); */

                this.background.displayWidth = this.sys.canvas.width;
                this.background.displayHeight = this.sys.canvas.height;
            }

            //-----------------------------------------------------------------------------------UPDATE

            update() {
                pseudoingame.x = perso.x - 25;
                pseudoingame.y = perso.y - 290;
                cursors.up.on("up", function (event) {
                    lumiere.play("clignotement");
                    camera.shake(1000, 0.025);

                    perso.setVelocity(0, 0);
                });
                if (cursors.up.isDown) {
                    /*    perso.displayWidth = 300;
                    perso.displayHeight = 600; */
                    perso.scale = -1;
                    /* perso.setVelocity(0, -200);
                    camera.scrollX = 200; */
                    /*    camera.fadeEffect.alpha = 0;
                    camera.fade(2000); */
                    /* camera.zoomTo(1, 1000);
                    camera.setBounds(0, 0, 1280, 200); */
                    /* camera.shake(1000, 0.025); */
                    // perso.play('walk');
                }
            }
        }
        // --------------------------Scene menu Boutique ------------------------------------------------

        //--- todo --------------------------CONFIGURATION ------------------------------------------------

        const config = {
            width: windowwidth + 40,
            height: windowheight - 50,
            pixelArt: false,
            scene: [SceneA, SceneB, SceneC],
            type: Phaser.AUTO,
            parent: "jeu",
            physics: {
                default: "arcade",
                arcade: {
                    gravity: { y: 0 }
                }
            },
            scale: {
                parent: "jeu",
                mode: Phaser.Scale.FIT,
                autoCenter: Phaser.Scale.CENTER_BOTH
            }
        };
        var game = new Phaser.Game(config);
    }); // FIN DU ONMOUNT
    const toucheclavier = (event) => {
        if (event === 122) {
            /* console.log("plein ecran !"); */
        }
    };
</script>

<svelte:window
    on:keydown={(event) => {
        if (event.key === "p") {
            console.log("touche p !");
        }
        /* console.log(event); */
    }}
    on:mousemove={() => {}}
/>

<div id="block">
    <div id="hud" class={hudcache ? "menucache" : ""}>
        <Chat id="chat" />
        <Hud
            bind:pseudo={joueur.pseudo}
            bind:cyberz={joueur.cyberz}
            bind:niv={joueur.niveau}
            bind:barredevie={joueur.sante}
            bind:sante={joueur.sante}
            bind:xp={joueur.xp}
            bind:srcface={faceimg}
            bind:kill={joueur.kill}
            bind:score={joueur.score}
            bind:inventaire={joueur.inventaire}
            bind:placeinventaire
        />
        <Stages score={joueur.score[0]} />
    </div>

    {#if jeucharger}
        <div id="blockright">
            <Cybershop bind:cyberz={joueur.cyberz} />
            <div id="hudjeu"><Hudjeu /></div>
            <div />
        </div>
    {/if}

    <div id="lecteur">
        <img
            src="img/play.png"
            alt=""
            id="play"
            on:click={() => {
                stopAudio(musique[track]);

                track++;

                if (track >= musique.length) {
                    track = 0;
                }
                musique[track].volume = 0.8;
                musique[track].play();
            }}
        />

        <img
            src="img/stop.png"
            alt=""
            id="pause"
            on:click={() => {
                stopAudio(musique[track]);
                stopAudio(musique[track + 1]);
                track = 0;
            }}
        />
    </div>
</div>

<style>
    @font-face {
        font-family: "scifi";
        src: url("/conthrax-sb.ttf");
    }
    #hudjeu {
        position: absolute;
        left: 50%;
        top: 95%;
        transform: translate(-50%, -90%);
        margin: 0;
    }
    #lecteur {
        position: absolute;
        cursor: url("/img/mouse2.png"), pointer;
        left: 50%;
        top: 95%;
        transform: translate(-50%, -90%);

        flex-direction: row;
        justify-content: space-between;
    }

    img {
        /* border-radius: 100%; */
        box-sizing: border-box;
        margin: 4px;
    }
    .menucache {
        opacity: 0;
    }

    #hud {
        z-index: 2;
        font-family: "scifi";
    }
    #blockright {
    }
    #test {
        position: absolute;
    }
</style>
